import { RotatingLines } from "react-loader-spinner";

export const GraphLoader = () => {
  return (
    <div className="d-flex justify-content-center align-items-center">
      <RotatingLines strokeColor="#001E6C" height={100} width={100} />
    </div>
  );
};
